/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';

interface GrabberIconProps {
  isVertical?: boolean,
  color?: string
}

/*
 * Defines the Design Language System (DLS) Grabber Icon component. Lets user know this is something that can 
 * be grabbed and likely dragged or resized.
 */
export const GrabberIcon = ({isVertical = false, color = '#BDBDBD'}: GrabberIconProps) => {
  return (
    !isVertical ? (
      <svg width="40" height="5" viewBox="0 0 40 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="2.5" y1="2.5" x2="37.5" y2="2.5" stroke={color} strokeWidth="5" strokeLinecap="round"/>
      </svg>
    ) : (
      <svg width="5" height="40" viewBox="0 0 5 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="2.5" y1="2.5" x2="2.5" y2="37.5" stroke={color} strokeWidth="5" strokeLinecap="round"/>
      </svg>
    )
    
  );
};
